import { KPI } from '../api/models';
import { APIService } from '../api/api.service';
import { Injectable } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ObservableMap } from './initiatives.service';
import * as R from 'ramda';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentalProfileService {

  constructor(
    private apiService: APIService,
  ) { }

  private environmentalProfilesByAssetType: ObservableMap<KPI.EnvironmentalProfile[]> = {};
  public getEnvironmentalProfilesByAssetType(assetTypeId: number): Observable<KPI.EnvironmentalProfile[]> {
    const key = this.getKey(arguments);
    if (!this.environmentalProfilesByAssetType[key]) {
      this.environmentalProfilesByAssetType[key] = this.apiService.get_environmental_profiles_by_asset_type(assetTypeId).pipe(
        pipe(shareReplay(1))
      )
    }
    return this.environmentalProfilesByAssetType[key];
  }

  private getKey(args: IArguments): string {
    return JSON.stringify(R.pickBy(R.complement(R.isNil), args));
  }

}
